import leaveByUrl, { NAMESPACE_TYPES } from '../../../namespaces/leave_by_url.js?vue3';
import { initGroupsShowApp } from '../../../groups/show/index.js?vue3';
import { initGroupReadme } from '../../../groups/init_group_readme.js?vue3';
import initReadMore from '~/read_more';
import { initGroupActions } from '../../../groups/show/actions/index.js?vue3';
import { addShortcutsExtension } from '../../../behaviors/shortcuts/index.js?vue3';
import ShortcutsNavigation from '~/behaviors/shortcuts/shortcuts_navigation';
import initNotificationsDropdown from '../../../notifications/index.js?vue3';

addShortcutsExtension(ShortcutsNavigation);
initNotificationsDropdown();
initGroupsShowApp();
initReadMore();
initGroupReadme();
initGroupActions();
leaveByUrl(NAMESPACE_TYPES.GROUP);
